/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Title1Inputs */

const zh_creditpack_title1 = /** @type {(inputs: Creditpack_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分充值包`)
};

const en_creditpack_title1 = /** @type {(inputs: Creditpack_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit Packs`)
};

const es_creditpack_title1 = /** @type {(inputs: Creditpack_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de Créditos`)
};

/**
* | output |
* | --- |
* | "Credit Packs" |
*
* @param {Creditpack_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_title1 = /** @type {((inputs?: Creditpack_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_title1(inputs)
	if (locale === "en") return en_creditpack_title1(inputs)
	return es_creditpack_title1(inputs)
});
export { creditpack_title1 as "creditPack_title" }